
const breadpayment = async (price) => {
    var merchantId = "7c30b5a0-acd0-4d18-b443-7b19908889ba";
    var programId = "2a1d717a-e4ea-43fc-9d2b-6844f06eda79";
    const request = await fetch(`https://api.platform.breadpayments.com/api/experience/servicing/as-low-as?merchantId=${merchantId}&amount=${Number(price)}&programId=${programId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })

    if (!request.ok) throw new Error('Network response was not ok.');
    const response = await request.json()
    return response
}

const breadModal = (price) => {
    //Bread 2.0
    let breadPlacements = []
    let placement = {};
    let currency = "USD";
    placement.allowCheckout = false;
    placement.domID = "product-grid"
    placement.order = {};
    placement.order.items = [];
    placement.order.subTotal = {value: price, currency: currency};
    placement.order.totalPrice = {value: price, currency: currency};
    placement.order.currency = currency;
    placement.order.totalShipping = {value: 0, currency: currency};
    placement.order.totalTax = {value: 0, currency: currency};
    placement.order.totalDiscounts = {value: 0, currency: currency};
    breadPlacements.push(placement);

    BreadPayments.registerPlacements(breadPlacements);
    
    BreadPayments.on("INSTALLMENT:APPLICATION_DECISIONED", (data) => {
      console.log("Bread Modal:", data)
      if (data && data.billingContact.email) {
        //Middleware to push to Klaviyo
        // fetch(`https://MERCHANT-SITE-URL/bread?email=${data.email}`);
        const customerData = {
          email: data.billingContact.email,
          phone: data.billingContact.phone,
          firstname: data.billingContact.name.givenName || "No Data",
          lastname: data.billingContact.name.familyName || "No Data",
          status: data.status || "No Data",
          city: data.billingContact.address.locality || "No Data",
          rigion: data.billingContact.address.region || "No Data",
          country: data.billingContact.address.country || "No Data",
          postalCode: data.billingContact.address.postalCode || "No Data",
        };

        console.log("customerData: ", customerData);

        // convert data to JSON Format
        const customerDataJson = JSON.stringify(customerData);
        // url
        const breadURL = "https://hooks.zapier.com/hooks/catch/11519004/39xzd24/";

        // Set up fetch options for the POSt request
        const fetchOptions = {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Accept": "application/json"
          },
          body: customerDataJson,
        };

        // Make the POST request
        fetch(breadURL, fetchOptions)
        .then((response) => {
          console.log("response: ", response);
        })
        .catch((error) => {
          console.error(error);
        });
      }
    });
    
    BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', () => {});
    BreadPayments.openExperienceForPlacement(breadPlacements);
}

const breadRoundUp = (dollarString) => {
  // parse the dollar string into floating point number
  const amount = parseFloat(dollarString.replace('$', ''));

  // check if amount has decimal part
  if (amount % 1 !== 0) {
      return '$' + Math.ceil(amount);
  }

  return dollarString;
}

document.addEventListener('DOMContentLoaded', function () {
    $cardGrid = $('#product-grid')
    $cardGrid.children().each( async function () {
        const breadPrice = await breadpayment($(this).data('price'))
        $(this).find('.breadpay').html(`<a data-bread-learmore data-price="${$(this).data('price')}">As low as ${breadRoundUp(breadPrice.asLowAs.paymentAmountText["en-us"])}/mo*</a>`).on('click', 'a', function(e) {
            e.preventDefault()
            // console.log($(this).data('price'))
            breadModal($(this).data('price'))
        })
    })
    
})